import React from 'react';
import { EnvironmentOperationMode, EnvironmentFlags } from '../models/EnvironmentModels';
import { ModeConfigurationFields } from './ModeConfigurationFields';

interface NormalOperationModeProps {
    mode: EnvironmentOperationMode;
    onIsEnabledChange: (value: boolean) => void;
    onPipelineChange: (value: number | null) => void;
    onRegionChange: (value: number | null) => void;
    onWorklaneChange: (value: number | null) => void;
    onFeatureFlagChange: (flagKey: keyof EnvironmentFlags, value: boolean | null) => void;
}

export const NormalOperationMode: React.FC<NormalOperationModeProps> = ({
    mode,
    onIsEnabledChange,
    onPipelineChange,
    onRegionChange,
    onWorklaneChange,
    onFeatureFlagChange,
}) => {
    return (
        <ModeConfigurationFields
            isEnabled={mode.isEnabled}
            pipeline={mode.pipeline}
            region={mode.region}
            worklane={mode.worklane}
            featureFlags={mode.featureFlags}
            onIsEnabledChange={onIsEnabledChange}
            onPipelineChange={onPipelineChange}
            onRegionChange={onRegionChange}
            onWorklaneChange={onWorklaneChange}
            onFeatureFlagChange={onFeatureFlagChange}
            readOnly={false}
            showModeConfig={true}
        />
    );
};
